import {
  put, all, call, select, takeEvery, takeLatest,
} from 'redux-saga/effects';
import { getCurrentAuthHeader } from 'domain/fuse/auth/utils';
import { morphShipmentToUI } from 'domain/order/utils';
import { exception } from 'circe/logger';
import { fetch, fetching, fetched } from './actions';
import { fetch as fetchApi } from '../book/api';
import { morphUsingState } from '../view/utils';

const doFetch = function* ({ payload }) {
  try {
    const { sid, iid } = payload;

    const state = yield select();

    yield put(fetching());

    const headers = yield call(getCurrentAuthHeader, state);

    const results = yield call(fetchApi, sid, iid, headers);

    if (!results) {
      throw new Error(`Shipment View failed to load ${sid}`);
    }

    const morphed = morphUsingState(morphShipmentToUI(results), state);

    yield put(fetched(morphed));
  } catch (e) {
    exception(e);
  }
};

export default function* () {
  yield all([takeLatest(fetch().type, doFetch)]);
}
